export default "__VITE_ASSET__BgP3k3I1__"